import React, { useState, useEffect, useContext } from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import "../components/styles/TaskFeeder.css";
import { BasicTable } from "../components/scripts/Tables";
import { ApiCall } from "../utility/ApiCalls";
import Loader from "react-loader-spinner";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import HourglassBottomOutlinedIcon from "@mui/icons-material/HourglassBottomOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckIcon from "@mui/icons-material/Check";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ClearIcon from "@mui/icons-material/Clear";
// import { Button } from "../components/scripts/Button";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import UserContext from "../components/Common/UserContext";
import menus from "../info.json";
import Api_Call from "../ApiCall";

const TaskFeeder = () => {
  const [taskFeeder, setTaskFeeder] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [startBtnDisabled, setStartBtnDisabled] = useState(false);
  const { userName: user } = useContext(UserContext);

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#333",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      // border: "1px solid #dadde9",
    },
  }));

  const colums = [
    {
      width: 30,
      Header: "",
      accessor: "Status",
      Cell: (props) => {
        return (
          <>
            {props.row.values.Status == "4" ? (
              <CheckCircleOutlinedIcon className="complete-icon" />
            ) : props.row.values.Status == "2" ? (
              <div className="processing-icon"></div>
            ) : props.row.values.Status == "1" ? (
              <HourglassBottomOutlinedIcon className="waiting-icon" />
            ) : props.row.values.Status == "3" ? (
              // <Tooltip title="This is warning" arrow>
              // <HtmlTooltip
              //   title={
              //     <>
              //       <ul style={{listStyle:'circle', background:'#333', color:'#fff', padding:'15px', paddingLeft:'20px'}}>
              //         <li>
              //           Case does not qualify for auto approval, sent to
              //           clinical review.
              //         </li>
              //         <li>Exception Raised. Require clinical Review.</li>
              //       </ul>
              //     </>
              //   }
              // >
              <WarningAmberIcon className="error-icon" />
            ) : (
              // </HtmlTooltip>
              // </Tooltip>
              ""
            )}
          </>
        );
      },
    },
    {
      width: 100,
      Header: "Filename",
      accessor: "FileName_CR",
    },
    {
      width: 100,
      Header: "Task ID",
      accessor: "Task_ID",
    },
    {
      width: 100,
      Header: "Priority",
      accessor: "Priority_CR",
    },
    {
      width: 100,
      Header: "Member ID",
      accessor: "MemberID_CR",
    },
    {
      width: 100,
      Header: "Data Extracted",
      accessor: "Extraction",
      Cell: (props) => {
        return (
          <>
            {props.row.values.Extraction == "0" ? (
              <MoreHorizIcon />
            ) : props.row.values.Extraction == "1" ? (
              <CheckIcon />
            ) : props.row.values.Extraction == "2" ? (
              <ClearIcon />
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      width: 100,
      // Header: "Extraction Confidence",
      Header: "Completion Status",
      accessor: "ConfidenceScore",
    },
    {
      width: 100,
      Header: "Business Validation",
      accessor: "Validation",
      Cell: (props) => {
        return (
          <>
            {props.row.values.Validation == "0" ? (
              <MoreHorizIcon />
            ) : props.row.values.Validation == "1" ? (
              <CheckIcon />
            ) : props.row.values.Validation == "2" ? (
              <ClearIcon />
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      width: 200,
      Header: "Pre Cert List",
      // accessor: "AuthCreation",
      accessor: "PreCertCPT",
      Cell: (props) => {
        return (
          <>
            {props.row.values.PreCertCPT == "0" ? (
              <MoreHorizIcon />
            ) : props.row.values.PreCertCPT == "1" ? (
              <CheckIcon />
            ) : props.row.values.PreCertCPT == "2" ? (
              <ClearIcon />
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      width: 150,
      Header: "Start Date",
      accessor: "ProcessStartDate_DT",
    },
    {
      width: 150,
      Header: "End Date",
      accessor: "ProcessEndDate_DT",
    },
    {
      width: 400,
      Header: "Last Activity",
      accessor: "Activity_CR",
    },
    {
      width: 100,
      Header: "Auth #",
      accessor: "AuthId",
    },
  ];

  // const taskFeederData = [
  //   {
  //     filename: "3350320.pdf",
  //     size: "250kb",
  //     created_date: "2022-11-03",
  //     status: "",
  //   },
  //   {
  //     filename: "3350320.pdf",
  //     size: "250kb",
  //     created_date: "2022-11-03",
  //     status: "",
  //   },
  //   {
  //     filename: "3350320.pdf",
  //     size: "250kb",
  //     created_date: "2022-11-03",
  //     status: "",
  //   },
  //   {
  //     filename: "3350320.pdf",
  //     size: "250kb",
  //     created_date: "2022-11-03",
  //     status: "",
  //   },
  // ];

  async function taskFeederAPI() {
    const api = new Api_Call();
    const data = await api.getData(
      "TASK_FEEDER/GET-UPDATES?module-name=taskfeed"
    );
    console.log(data);
    if (data.body) {
      setTaskFeeder(data.body);
    }
    setLoading(false);
  }

  async function taskfeederpocessAPI() {
    setLoading(true);
    const api = new Api_Call();
    const data = await api.getData("TASK_FEEDER/START");
    setLoading(false);
  }

  useEffect(() => {
    if (user !== null) {
      let interval = setInterval(() => {
        taskFeederAPI();
      }, 3000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [user]);

  const startProcessing = () => {
    setStartBtnDisabled(true);
    taskfeederpocessAPI();
  };

  return (
    <>
      <Box className="taskFeeder-container">
        <Box className="taskFeeder-title">
          <Box>
            <Typography variant="h4">Task Feeder</Typography>
          </Box>
          <Box className="taskfeeder-top-right-btns">
            <Button
              variant="contained"
              className="materialButton"
              onClick={startProcessing}
              disabled={startBtnDisabled ? "disabled" : null}
            >
              Start Processing
            </Button>
          </Box>
        </Box>
        <Box className="taskFeederTable">
          {isLoading ? (
            <Box className="loaderParent">
              <Loader type="Puff" color="#00BFFF" height={100} width={100} />
            </Box>
          ) : (
            <>
              <Typography variant="subtitle2">
                Data Source : aws:s3:::vcarefaxes
              </Typography>
              <BasicTable
                columns={colums}
                tableData={taskFeeder}
                tableType="default"
              />
              <ul className="legends">
                <li>
                  <CheckCircleOutlinedIcon className="complete-icon" />
                  Done
                </li>
                <li>
                  <div className="processing-icon-stop"></div>Processing
                </li>
                <li>
                  <HourglassBottomOutlinedIcon className="waiting-icon" />
                  Waiting
                </li>
                <li>
                  <WarningAmberIcon className="error-icon" />
                  Review Required
                </li>
              </ul>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default TaskFeeder;
